export enum Locations {
  mainland = "Mainland",
  island = "Vancouver Island",
}

export const LOCATIONS = Object.entries(Locations).map(
  ([key, value]) => ({ code: key, display: value })
);

const MainlandPorts = {
  "Vancouver": "247",
  "Squamish": "248",
  "New Westminster": "250",
  "Deltaport": "276",
  "Prince Rupert": "251",
}

const ExtraWeeklyMainlandPorts = {
  "Stewart": "261",
  "Riddley Island": "271"
}

const IslandPorts = {
  "Cowichan Bay": "253",
  "Victoria": "252",
  "Crofton": "254",
  "Chemainus": "255",
  "Harmac": "257",
  "Nanaimo": "258",
  "Port Alberni": "259",
}

const ExtraWeeklyIslandPorts = {
  "Ladysmith": "256"
}

export const MAINLANDPORTS = Object.entries(MainlandPorts).map(
  ([key, value]) => ({ code: value, display: key })
);

export const ISLANDPORTS = Object.entries(IslandPorts).map(
  ([key, value]) => ({ code: value, display: key })
);

export const WEEKLYMAINLANDPORTS = [
  ...MAINLANDPORTS,
  ...Object.entries(ExtraWeeklyMainlandPorts).map(
    ([key, value]) => ({ code: value, display: key })
  )
]

export const WEEKLYISLANDPORTS = [
  ...ISLANDPORTS,
  ...Object.entries(ExtraWeeklyIslandPorts).map(
    ([key, value]) => ({ code: value, display: key })
  )
]

export enum AllocationType {
  daily = "daily-allocations",
  weekly = "weekly-allocations"
}